import { actionTypes } from '../constants';

export const selectedRecordChanged = (value) => ({
  type: actionTypes.attachmentsFilterSelectedRecordChanged,
  payload: value,
});

export const selectedDocTypeChanged = (value) => ({
  type: actionTypes.attachmentsFilterSelectedDocTypeChanged,
  payload: value,
});

export const searchChanged = (value) => ({
  type: actionTypes.attachmentsFilterSearchChanged,
  payload: value,
});

export const filterReset = () => ({
  type: actionTypes.attachmentsFilterReset,
});
